export default __webpack_public_path__ + "static/media/23-exploding-head_1f92f.e2178065.png";